/* global euAdminConfig */
import Cookies from 'js-cookie';
import { Modal } from 'bootstrap';

const initial = () => {
    const setDomainShown = (domainName) => {
        Cookies.set(`shownReminder-${domainName}`, true, { expires: euAdminConfig.purchaseFormReminderExpires / 86400 });
    };
    const showModal = (domain) => {
        const modal = Modal.getOrCreateInstance(domain);
        modal.show();

        setDomainShown(domain.getAttribute('data-domain'));
    };

    const isDomainShown = (domainName) => Cookies.get(`shownReminder-${domainName}`);

    const hideModal = (domain) => {
        const modal = Modal.getOrCreateInstance(domain);
        modal.hide();
    };

    const switchModals = (fromDomain, toDomain) => {
        fromDomain.addEventListener('hidden.bs.modal', () => {
            showModal(toDomain);
        });

        hideModal(fromDomain);
    };

    const getDomainsThatAreNotYetBeenShown = (nodeList) => {
        let domainKey = 0;

        const domains = [];
        nodeList.forEach((domainElement) => {
            if (!isDomainShown(domainElement.getAttribute('data-domain'))) {
                domains[domainKey] = domainElement;
                domainKey += 1;
            }
        });

        return domains;
    };

    const domains = getDomainsThatAreNotYetBeenShown(document.querySelectorAll('.domain-expires'));

    if (!domains.length) {
        return;
    }

    showModal(domains[0]);

    domains.forEach((domain, key) => {
        const nextDomain = domains[key + 1];
        if (nextDomain) {
            switchModals(domain, nextDomain);
        }

        document.addEventListener('click', (event) => {
            if (!event.target.matches('.continue-payment')) return;
            const expiresModal = Modal.getOrCreateInstance(event.target.closest('.modal'));
            expiresModal.hide();
        }, false);
    });
};

export default initial;
